const updates = [
  { time: '10分钟前', title: '某热门综艺最新一期预告片发布，看点满满引期待', tag: '综艺', hot: true },
  { time: '30分钟前', title: '某流量明星新代言官宣，粉丝开启疯狂安利模式', tag: '品牌代言', hot: true },
  { time: '1小时前', title: '某影视剧官方发布角色定妆照，网友评论两极分化', tag: '影视爆料', hot: false },
  { time: '2小时前', title: '网红圈最新争议事件持续发酵，多方当事人表态', tag: '网红八卦', hot: true },
  { time: '3小时前', title: '某知名主持人宣布暂别荧幕，观众表示不舍', tag: '娱乐圈', hot: false },
  { time: '5小时前', title: '国际娱乐新闻：好莱坞某大制作电影推迟上映', tag: '国际吃瓜', hot: false },
  { time: '7小时前', title: '某选秀节目的选手背景被扒出，引发讨论', tag: '综艺', hot: false },
  { time: '10小时前', title: '社交媒体平台热议：今年最值得期待的综艺回归', tag: '热议话题', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-500"></span>
            </span>
            <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">实时更新</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            吃瓜快讯
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            最新八卦资讯滚动更新，吃瓜群众在线追踪第一手消息
          </p>
        </div>

        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-200"></div>

          <div className="flex flex-col gap-2">
            {updates.map((update, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pl-12 py-3">
                <div className={`absolute left-[12px] top-[18px] w-[15px] h-[15px] rounded-full border-2 flex items-center justify-center ${
                  update.hot
                    ? 'border-primary-500 bg-primary-100'
                    : 'border-background-300 bg-background-50'
                }`}>
                  {update.hot && <div className="w-[7px] h-[7px] rounded-full bg-primary-500"></div>}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-xs text-foreground-400 mb-1">{update.time}</p>
                  <h3 className="text-sm font-label font-medium text-foreground-900 leading-snug">
                    {update.title}
                  </h3>
                </div>

                <span className={`flex-shrink-0 px-2 py-0.5 rounded text-[10px] font-label whitespace-nowrap ${
                  update.hot
                    ? 'bg-primary-50 text-primary-600'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {update.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}